<header>
  <div class="container">
    <div class="row align-items-center">
      <div class="col mr-auto">
        <app-logo [width]="'100px'"></app-logo>
      </div>
      <div *ngIf="bootstrapLicenseData.getStandardsTypesLeftInfo" class="col text-right">
        <app-hint-error placement="bottom" [text]="bootstrapLicenseData.getStandardsTypesLeftInfo"></app-hint-error>
      </div>
      <div class="col-auto">
        <app-logout [position]="LogoutPosition.Right"></app-logout>
      </div>
    </div>
  </div>
</header>
